var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGCoin = function SvgGCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A69AE",
    d: "M6.644 1.992 5.018 3.045q-.673.436-1.246.994l1.626-1.053c.38-.37.798-.704 1.246-.994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#044899",
    d: "M5.399 2.985 3.772 4.038c-.26.24-.5.513-.717.798l1.626-1.053c.218-.285.457-.558.718-.798"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A69AE",
    d: "m17.175 21.855 1.626-1.053c-1.329.86-2.926 1.344-4.675 1.338L12.5 23.193c1.748.006 3.346-.478 4.675-1.338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#044899",
    d: "m13.009 22.07-1.626 1.052c.181.022.372.034.563.046.18.012.372.024.552.025l1.626-1.053c-.18 0-.371-.013-.552-.024a10 10 0 0 1-.563-.047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A69AE",
    d: "M4.68 3.783 3.054 4.836C1.715 6.5.958 8.706 1.025 11.217l1.626-1.053c-.066-2.512.69-4.716 2.03-6.38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#044899",
    d: "m2.654 10.164-1.626 1.053c.005.192.02.396.036.59.016.203.032.407.057.6l1.626-1.052a12 12 0 0 1-.057-.602 12 12 0 0 1-.036-.589"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A69AE",
    d: "m6.66 18.956-1.626 1.052c1.761 1.692 3.989 2.825 6.35 3.114l1.627-1.053c-2.362-.288-4.59-1.422-6.351-3.113"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#044899",
    d: "M5.8 18.059 4.172 19.11c.265.316.558.612.86.898l1.626-1.053a11 11 0 0 1-.86-.897"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A69AE",
    d: "M2.746 11.355 1.12 12.408c.327 2.518 1.439 4.85 3.054 6.703L5.8 18.058c-1.615-1.852-2.727-4.185-3.054-6.703"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_3285_16978)",
    d: "M18.55 5.911c1.288 1.512 2.185 3.393 2.473 5.418l1.688.107c-.328-2.529-1.44-4.861-3.065-6.715z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_3285_16978)",
    d: "M12.587 2.524c1.9.259 3.68 1.161 5.124 2.512l1.075-1.212c-1.761-1.68-3.989-2.814-6.34-3.102z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_3285_16978)",
    d: "M21.116 12.52c.028 2.008-.582 3.794-1.645 5.146l1.287 1.372c1.348-1.664 2.114-3.889 2.046-6.412z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_3285_16978)",
    d: "M6.691 4.327c1.248-1.17 2.903-1.865 4.781-1.874L11.331.651c-2.34-.01-4.42.862-5.934 2.335z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_3285_16978)",
    d: "m20.03 19.825-1.267-1.372c-1.248 1.17-2.903 1.866-4.78 1.885l.14 1.802c2.33.009 4.392-.853 5.906-2.315"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_3285_16978)",
    d: "M4.338 10.272c-.037-2.01.573-3.796 1.635-5.158L4.68 3.784c-1.34 1.665-2.096 3.869-2.03 6.38z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_3285_16978)",
    d: "M5.47 10.93c.335 4.28 3.861 7.96 7.86 8.214 3.997.253 6.98-3.015 6.644-7.294-.334-4.269-3.861-7.95-7.86-8.204-3.997-.253-6.979 3.015-6.645 7.284m3.61 5.01a9 9 0 0 1-.521-.535c-.967-1.117-1.637-2.515-1.835-4.032a5 5 0 0 1-.04-.366 4 4 0 0 1-.017-.353c-.038-1.507.418-2.834 1.219-3.84a6 6 0 0 1 .432-.473c.91-.882 2.159-1.41 3.568-1.407.11-.004.22.004.34.011.111.007.222.014.333.032 1.413.175 2.756.858 3.814 1.864.174.171.348.353.513.545a7.67 7.67 0 0 1 1.845 4.033c.02.119.028.237.038.355.01.128.02.246.018.364.04 1.518-.426 2.854-1.226 3.86a4.4 4.4 0 0 1-.444.463c-.91.881-2.15 1.4-3.549 1.397-.11.003-.22-.004-.33-.01-.121-.008-.232-.015-.343-.033-1.423-.176-2.755-.858-3.815-1.875"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_3285_16978)",
    d: "M12.868 20.267c-1.899-.248-3.68-1.161-5.124-2.501l-1.086 1.19c1.762 1.691 3.99 2.825 6.351 3.113z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_3285_16978)",
    d: "M6.895 16.88c-1.288-1.512-2.185-3.394-2.463-5.418l-1.688-.107c.327 2.518 1.44 4.85 3.054 6.703z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_3285_16978)",
    d: "M22.804 12.627c.005-.192-.011-.396-.027-.6a6 6 0 0 0-.066-.59l-1.688-.108c-.288-2.024-1.185-3.906-2.473-5.418l1.096-1.19a9.5 9.5 0 0 0-.86-.897l-1.074 1.212c-1.445-1.351-3.225-2.253-5.125-2.513l-.14-1.801c-.183-.033-.374-.045-.555-.057a5 5 0 0 0-.56-.014l.14 1.802c-1.878.009-3.533.704-4.78 1.874L5.397 2.985c-.261.24-.5.513-.717.798l1.294 1.33C4.91 6.476 4.3 8.263 4.339 10.271l-1.688-.107c.005.192.021.396.037.59.016.203.032.407.057.6l1.687.107c.279 2.024 1.176 3.906 2.463 5.418l-1.097 1.179c.265.315.558.611.86.897l1.086-1.19c1.445 1.34 3.225 2.254 5.124 2.502l.14 1.802c.182.022.373.034.564.046.181.012.372.024.552.024l-.142-1.802c1.878-.02 3.533-.715 4.78-1.884l1.267 1.371c.261-.24.5-.501.728-.786l-1.287-1.372c1.064-1.352 1.674-3.139 1.646-5.146zm-10.689-8.98c3.998.253 7.525 3.934 7.86 8.203.335 4.279-2.648 7.548-6.646 7.294-3.997-.253-7.524-3.934-7.86-8.214-.334-4.269 2.648-7.537 6.646-7.284"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_3285_16978)",
    d: "M18.77 11.773c.01.129.019.247.018.364.039 1.518-.427 2.854-1.227 3.86a4.4 4.4 0 0 1-.443.463c-.91.88-2.15 1.4-3.55 1.397-.109.003-.22-.004-.33-.01-.12-.008-.23-.015-.342-.033-1.423-.175-2.756-.858-3.815-1.875a9 9 0 0 1-.522-.534c-.967-1.118-1.636-2.516-1.835-4.033a4 4 0 0 1-.039-.365l-.014-.217-.003-.137c-.039-1.507.417-2.833 1.218-3.839.137-.162.275-.324.433-.474.91-.881 2.158-1.41 3.568-1.406.11-.004.22.003.34.01l.007.001c.108.007.216.014.325.032 1.414.174 2.757.857 3.815 1.863.173.171.347.353.512.545a7.67 7.67 0 0 1 1.869 4.22z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_3285_16978)",
    d: "M14.93 10.963a.28.28 0 0 1 .353.283 5.8 5.8 0 0 1-.249 1.585 5 5 0 0 1-.712 1.444 3.3 3.3 0 0 1-.965.921q-.526.322-1.023.37a1.64 1.64 0 0 1-.75-.106 1.7 1.7 0 0 1-.646-.464 2.9 2.9 0 0 1-.47-.852 4.8 4.8 0 0 1-.252-1.233q-.12-1.4.175-2.476.294-1.077.815-1.825.531-.75 1.166-1.148.645-.399 1.225-.454.414-.038.728.085.323.123.542.365.219.231.331.57.082.22.124.463a.28.28 0 0 1-.195.311l-.906.27c-.147.043-.298-.045-.36-.19a1 1 0 0 0-.205-.327q-.171-.17-.368-.151-.26.024-.537.443a4.4 4.4 0 0 0-.496 1.042q-.218.632-.341 1.376-.125.745-.085 1.45.057.673.269.948.22.264.521.236a.96.96 0 0 0 .416-.148q.219-.13.378-.342a1.9 1.9 0 0 0 .314-.736c.032-.183-.138-.315-.31-.271l-.374.094c-.19.048-.368-.114-.349-.318l.044-.461a.29.29 0 0 1 .222-.26l.741-.174q.39-.09.818-.207.22-.06.411-.113"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_3285_16978)",
    d: "M18.55 5.911c1.288 1.512 2.185 3.393 2.473 5.418l1.688.107c-.328-2.529-1.44-4.862-3.065-6.715z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_3285_16978)",
    d: "M12.587 2.524c1.9.259 3.68 1.161 5.124 2.512l1.075-1.212c-1.76-1.68-3.989-2.814-6.34-3.102z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_3285_16978)",
    d: "M21.116 12.52c.028 2.008-.582 3.794-1.645 5.146l1.287 1.372c1.348-1.664 2.114-3.889 2.046-6.412z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_3285_16978)",
    d: "M6.691 4.327c1.248-1.17 2.903-1.865 4.781-1.874L11.331.65c-2.34-.01-4.42.862-5.934 2.334z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_3285_16978)",
    d: "m20.03 19.825-1.267-1.372c-1.248 1.17-2.903 1.865-4.78 1.885l.14 1.802c2.33.008 4.392-.853 5.906-2.315"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear_3285_16978)",
    d: "M4.338 10.271c-.037-2.008.573-3.795 1.635-5.157L4.68 3.784c-1.34 1.665-2.096 3.868-2.03 6.38z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_3285_16978)",
    d: "M5.47 10.93c.335 4.28 3.861 7.96 7.86 8.214 3.997.253 6.98-3.015 6.644-7.295-.334-4.268-3.861-7.95-7.86-8.203-3.997-.253-6.979 3.015-6.645 7.284m3.61 5.01a9 9 0 0 1-.521-.535c-.967-1.118-1.637-2.515-1.835-4.033a5 5 0 0 1-.04-.365c-.008-.118-.018-.236-.017-.353-.038-1.507.418-2.834 1.219-3.84.137-.162.274-.323.432-.473.91-.882 2.159-1.41 3.568-1.407.11-.004.22.003.34.011.111.007.222.014.333.032 1.413.175 2.756.858 3.814 1.864.174.17.348.353.513.544a7.67 7.67 0 0 1 1.883 4.389c.01.128.02.246.018.364.04 1.518-.426 2.854-1.226 3.86a4.4 4.4 0 0 1-.444.463c-.91.881-2.15 1.4-3.549 1.397-.11.003-.22-.004-.33-.01-.121-.008-.231-.015-.343-.033-1.423-.176-2.755-.858-3.815-1.875"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_3285_16978)",
    d: "M12.868 20.267c-1.899-.248-3.68-1.161-5.124-2.501l-1.086 1.19c1.762 1.691 3.99 2.825 6.351 3.113z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_3285_16978)",
    d: "M6.895 16.88c-1.288-1.513-2.185-3.394-2.463-5.418l-1.688-.107c.327 2.518 1.44 4.85 3.054 6.703z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_3285_16978)",
    d: "M14.93 10.963a.28.28 0 0 1 .353.283 5.8 5.8 0 0 1-.249 1.585 5 5 0 0 1-.712 1.444 3.3 3.3 0 0 1-.965.921q-.526.322-1.023.37a1.64 1.64 0 0 1-.75-.105 1.7 1.7 0 0 1-.646-.465 2.9 2.9 0 0 1-.47-.852 4.8 4.8 0 0 1-.252-1.233q-.12-1.4.175-2.476.294-1.077.815-1.825.531-.75 1.166-1.148.645-.399 1.225-.453.414-.039.728.084.323.123.542.365.219.231.331.57.082.22.124.463a.28.28 0 0 1-.195.311l-.906.27c-.147.043-.298-.045-.36-.19a1 1 0 0 0-.205-.327q-.171-.17-.368-.151-.26.024-.537.444a4.4 4.4 0 0 0-.496 1.04q-.218.633-.341 1.377-.125.745-.085 1.45.057.674.269.949.22.263.521.235a.96.96 0 0 0 .416-.148q.219-.13.378-.342a1.9 1.9 0 0 0 .314-.736c.032-.183-.138-.315-.31-.271l-.374.094c-.19.048-.368-.114-.349-.318l.044-.461a.29.29 0 0 1 .222-.26l.741-.174q.39-.09.818-.207.22-.06.411-.113"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3285_16978",
    x1: 9.926,
    x2: 17.483,
    y1: 21.652,
    y2: 1.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3285_16978",
    x1: 7.637,
    x2: 22.909,
    y1: 22.909,
    y2: 2.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C83C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#398BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4198FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#369DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3285_16978",
    x1: 7.637,
    x2: 22.909,
    y1: 22.909,
    y2: 2.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C83C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#398BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4198FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#369DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3285_16978",
    x1: 12.039,
    x2: 16.026,
    y1: 7.194,
    y2: 13.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3285_16978",
    x1: 21,
    x2: 2.318,
    y1: 1.227,
    y2: 19.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479CF3"
  })))));
};
export default SvgGCoin;